/**
 * Welcome.jsx — /welcome. A standalone booth/kiosk mini-game (FounderBoard Runner)
 * lives at public/welcome.html as a fully self-contained static page (its own
 * <html>/<body> reset, canvas game loop, lead-capture form). It's rendered via
 * iframe rather than inlined so its global CSS reset (html,body{overflow:hidden})
 * and script never touch the rest of the SPA.
 */
import React from 'react';

const Welcome = () => (
  <iframe
    src="/welcome.html"
    title="FounderBoard Runner"
    style={{ position: 'fixed', inset: 0, width: '100%', height: '100%', border: 'none' }}
  />
);

export default Welcome;
